import React, { Component } from "react";
import { connect } from "react-redux";
import TextField from "material-ui/TextField";
import Avatar from "material-ui/Avatar";
import Chip from "material-ui/Chip";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIcon from "material-ui/svg-icons/editor/drag-handle";
import PaidIcon from "material-ui/svg-icons/editor/attach-money";
import FreeIcon from "material-ui/svg-icons/editor/money-off";

import List from "../../app/List";
import { capitalize, normalize } from "../../utils";
import {
  addOption,
  deleteOption,
  togglePaidOption,
  reorderOptions,
} from "./actions";

import "../common.css";
import "./Accomodation.css";

class Filters extends Component {
  searchChanged = (e, value) => {
    this.props.submit(value);
  };

  componentDidUpdate(prevProps) {
    if (this.props.opened && prevProps.opened !== this.props.opened) {
      this.refs.search.focus();
    }
  }

  render() {
    return (
      <form onSubmit={this.submit} className="list--filters">
        <TextField
          className="input-search"
          name="q"
          hintText="Que recherchez-vous ?"
          floatingLabelText="Votre recherche"
          value={this.props.search}
          onChange={this.searchChanged}
          ref="search"
        />
      </form>
    );
  }
}

class AccomodationOptions extends Component {
  state = {
    filtering: false,
    accomodationOptions: [],
  };

  componentDidMount() {
    const { accomodationOptions, options } = this.props;
    if (accomodationOptions && options) {
      const optionsById = options.reduce((acc, option) => {
        if (acc[`${option.code}`] === undefined) {
          acc[`${option.code}`] = option;
          acc[`${option.code}`][`libelle${capitalize(option.lang)}`] =
            option.libelle;
        } else {
          acc[`${option.code}`][`libelle${capitalize(option.lang)}`] =
            option.libelle;
        }
        return acc;
      }, {});
      this.setState({ optionsById, accomodationOptions }, this.filterOptions);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.accomodationOptions.length !==
      this.props.accomodationOptions.length
    ) {
      this.setState(
        { accomodationOptions: this.props.accomodationOptions },
        this.filterOptions
      );
    } else if (
      this.props.accomodationOptions.reduce((acc, option, index) => {
        return (
          acc ||
          option.option != prevProps.accomodationOptions[index].option ||
          option.order != prevProps.accomodationOptions[index].order ||
          option.paid !== prevProps.accomodationOptions[index].paid
        );
      }, false)
    ) {
      this.setState({ accomodationOptions: this.props.accomodationOptions });
    }
  }

  sortByOrder = (optionA, optionB) => {
    const { optionsById } = this.state;
    const orderA =
      optionA.order !== undefined
        ? optionA.order
        : optionsById[`${optionA.option}`].order;
    const orderB =
      optionB.order !== undefined
        ? optionB.order
        : optionsById[`${optionB.option}`].order;

    if (orderA < orderB) return -1;
    if (orderA > orderB) return 1;

    const libelleA = optionA.libelleFr
      ? optionA.libelleFr
      : optionsById[`${optionA.option}`].libelleFr;
    const libelleB = optionB.libelleFr
      ? optionB.libelleFr
      : optionsById[`${optionB.option}`].libelleFr;

    if (libelleA < libelleB) return -1;
    if (libelleA > libelleB) return 1;
    return 0;
  };

  sortByKind = (optionA, optionB) => {
    const { optionsById } = this.state;
    const kindA = optionA.kind
      ? optionA.kind
      : optionsById[`${optionA.option}`].kind;
    const kindB = optionB.kind
      ? optionB.kind
      : optionsById[`${optionB.option}`].kind;

    if (kindA < kindB) return -1;
    if (kindA > kindB) return 1;

    const libelleA = optionA.libelleFr
      ? optionA.libelleFr
      : optionsById[`${optionA.option}`].libelleFr;
    const libelleB = optionB.libelleFr
      ? optionB.libelleFr
      : optionsById[`${optionB.option}`].libelleFr;

    if (libelleA < libelleB) return -1;
    if (libelleA > libelleB) return 1;
    return 0;
  };

  colorByKind = (kind) => {
    if (kind === "equipments") return { backgroundColor: "#ddd" };
    else if (kind === "services") return { backgroundColor: "#78d27a" };
    else if (kind === "conforts") return { backgroundColor: "#d48f32" };
    else if (kind === "spokenLanguages") return { backgroundColor: "#f44336" };
    else if (kind.indexOf("pets") !== -1) return { backgroundColor: "#ad1236" };
    else {
      return { backgroundColor: "#ccc" };
    }
  };

  sortOptionKinds = (kindA, kindB) => {
    if (kindA.indexOf("pets") !== -1 && kindB.indexOf("pets") === -1) return 1;
    else if (kindB.indexOf("pets") !== -1 && kindA.indexOf("pets") === -1)
      return -1;
    else return kindA > kindB;
  };

  optionStyles = (id) => {
    const base = { margin: "4px", color: "#000" };
    const { optionsById } = this.state;
    if (optionsById !== undefined && optionsById[id] !== undefined) {
      const option = optionsById[id];
      return { ...base, ...this.colorByKind(option.kind) };
    }
    return base;
  };

  deleteOption = (code) => () => {
    this.props.deleteOption(this.props.merchantCode, code);
  };

  togglePaidOption = (code) => () => {
    this.props.togglePaidOption(this.props.merchantCode, code);
  };

  onDragStart = () => {};

  onDragEnd = (result) => {
    if (result.destination) {
      const srcIndex = result.source.index;
      const destIndex = result.destination.index;
      const kind = result.source.droppableId.replace("droppable", "");
      const { accomodationOptions, optionsById } = this.state;
      const accomodationOptionsSorted = accomodationOptions
        .filter(
          (accomodationOption) =>
            optionsById[`${accomodationOption.option}`].kind === kind
        )
        .sort(this.sortByOrder);
      const accomodationOptionsNotImpacted = accomodationOptions.filter(
        (accomodationOption) =>
          optionsById[`${accomodationOption.option}`].kind !== kind
      );
      const possibleAccomodationOptions = accomodationOptionsSorted.filter(
        (accomodationOption, index) => {
          return index === result.source.index;
        }
      );
      if (possibleAccomodationOptions.length === 1) {
        const optionDragged = possibleAccomodationOptions[0];

        const accomodationOptionsReordered =
          destIndex < srcIndex
            ? [
                ...accomodationOptionsSorted.slice(0, destIndex),
                optionDragged,
                ...accomodationOptionsSorted.slice(destIndex, srcIndex),
                ...accomodationOptionsSorted.slice(srcIndex + 1),
              ]
            : [
                ...accomodationOptionsSorted.slice(0, srcIndex),
                ...accomodationOptionsSorted.slice(srcIndex + 1, destIndex + 1),
                optionDragged,
                ...accomodationOptionsSorted.slice(destIndex + 1),
              ];
        this.setState(
          {
            accomodationOptions: [
              ...accomodationOptionsNotImpacted,
              ...accomodationOptionsReordered.map((option, index) => {
                return { ...option, order: index };
              }),
            ],
          },
          this.props.reorderOptions(
            this.props.merchantCode,
            accomodationOptionsReordered.map((option, index) => {
              return { id: option.id, order: index };
            })
          )
        );
      }
    }
  };

  renderAccomodationOptionsByKind = (kind) => {
    // const { accomodationOptions } = this.props
    const { accomodationOptions, optionsById } = this.state;
    return (
      <Droppable droppableId={`droppable${kind}`} type={kind} key={kind}>
        {(provided, snapshot) => (
          <div
            className="accomodation-options-by-kind-wrapper"
            ref={provided.innerRef}
          >
            {accomodationOptions
              .filter(
                (accomodationOption) =>
                  optionsById[`${accomodationOption.option}`].kind === kind
              )
              .sort(this.sortByOrder)
              .map((accomodationOption, index) => (
                <Draggable
                  key={accomodationOption.id}
                  draggableId={accomodationOption.id}
                  index={index}
                  type={kind}
                >
                  {(provided, snapshot) => (
                    <div>
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="accomodation-option-chip-wrapper">
                          <DragIcon className="accomodation-option-drag-icon" />
                          <Chip
                            className="accomodation-option-chip"
                            key={accomodationOption.option}
                            onRequestDelete={this.deleteOption(
                              accomodationOption.option
                            )}
                            style={this.optionStyles(accomodationOption.option)}
                            labelStyle={{
                              maxWidth: "220px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <Avatar
                              backgroundColor="#00000013"
                              color="#444"
                              icon={
                                accomodationOption.paid ? (
                                  <PaidIcon />
                                ) : (
                                  <FreeIcon />
                                )
                              }
                              onClick={this.togglePaidOption(
                                accomodationOption.option
                              )}
                            />
                            {
                              optionsById[`${accomodationOption.option}`]
                                .libelleFr
                            }
                          </Chip>
                        </div>
                      </div>
                      {provided.placeholder}
                    </div>
                  )}
                </Draggable>
              ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  };

  renderAccomodationOptions = () => {
    const { accomodationOptions, optionsById } = this.state;
    const optionsKinds =
      optionsById !== undefined
        ? accomodationOptions
            .reduce((acc, accomodationOption) => {
              const optionKind =
                optionsById[`${accomodationOption.option}`].kind;
              const isKindPresent = acc.indexOf(optionKind) !== -1;
              return isKindPresent ? acc : [...acc, optionKind];
            }, [])
            .sort(this.sortOptionKinds)
        : [];
    return optionsById !== undefined ? (
      <div className="card-container">
        <div className="card">
          <div className="title">Les options présentes sur l'hébergement</div>
          <div className="inner accomodation-options-inner">
            <DragDropContext
              onDragStart={this.onDragStart}
              onDragEnd={this.onDragEnd}
            >
              <div className="accomodation-options-wrapper">
                {optionsKinds.map((optionKind) =>
                  this.renderAccomodationOptionsByKind(optionKind)
                )}
              </div>
            </DragDropContext>
          </div>
        </div>
      </div>
    ) : null;
  };

  transformKind = (kind) => {
    if (kind === "equipments") return "Equipement";
    else if (kind === "services") return "Service";
    else if (kind === "comforts") return "Confort";
    else if (kind === "spokenLanguages") return "Langue";
    else if (kind === "pets_allowed" || kind === "pets_surcharge")
      return "Animaux";
    return "Option";
  };

  filterOptions = () => {
    const { accomodationOptions, optionsById, search } = this.state;
    const options = Object.keys(optionsById)
      .map((optionId) => {
        const option = optionsById[optionId];
        const kind = this.transformKind(option.kind);
        return { ...option, id: option.code, kind };
      })
      .filter((option) => {
        const isPresentInAccomodationOptions =
          accomodationOptions.filter(
            (accomodationOption) => accomodationOption.option === option.code
          ).length > 0;
        const labelFr = normalize(option.libelleFr);
        const labelEn = normalize(option.libelleEn);
        const searchLowerCase = normalize(search);
        const doesMatchSearch =
          search !== undefined && search.length > 0
            ? option.code == search ||
              labelFr.indexOf(searchLowerCase) != -1 ||
              labelEn.indexOf(searchLowerCase) != -1
            : true;
        return !isPresentInAccomodationOptions && doesMatchSearch;
      })
      .sort(this.sortByKind);
    this.setState({ options: options });
  };

  renderOptions = () => {
    const { filtering, options } = this.state;
    return options !== undefined ? (
      <div className="card-container option-list list-max-height">
        <List
          title="Les options disponibles"
          model={[
            { label: "Type", target: "kind" },
            { label: "Libelle français", target: "libelleFr" },
            { label: "Libelle anglais", target: "libelleEn" },
          ]}
          filters={
            <Filters
              opened={filtering}
              search={this.state.search}
              submit={(search) => {
                this.setState({ search }, this.filterOptions);
              }}
            />
          }
          toggleFiltering={() => {
            this.setState({ filtering: !filtering });
          }}
          list={{ filtering, options }}
          rows={options}
          addSelected={true}
          addCallback={(a) => () => {
            this.props.addOption(this.props.merchantCode, a);
          }}
        />
      </div>
    ) : null;
  };

  render() {
    return (
      <div>
        {this.renderAccomodationOptions()}
        {this.renderOptions()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  merchantCode: state.merchant.detail.code,
  options: state.accomodation.options,
  accomodationOptions: state.accomodation.accomodationOptions,
});

const mapDispatchToProps = (dispatch) => ({
  addOption: (merchantCode, optionCode) => {
    dispatch(addOption(merchantCode, optionCode));
  },
  deleteOption: (merchantCode, optionCode) => {
    dispatch(deleteOption(merchantCode, optionCode));
  },
  togglePaidOption: (merchantCode, optionCode) => {
    dispatch(togglePaidOption(merchantCode, optionCode));
  },
  reorderOptions: (merchantCode, options) => () => {
    dispatch(reorderOptions(merchantCode, options));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccomodationOptions);



// WEBPACK FOOTER //
// ./src/merchant/accomodation/AccomodationOptions.js